// extracted by mini-css-extract-plugin
export default {"root":"root___y0Nig","hidden":"hidden___QNr3P"};